module.exports = __webpack_public_path__ + "static/media/check.a60953d3.svg";